import axios from "axios";

export const api = axios.create({
    // baseURL: "https://byo-sync-backend-testing.vercel.app/api/v1",
    baseURL: "https://backendapi.byosync.in/api/v1",
    // baseURL: "http://localhost:7000/api/v1",
    withCredentials: true
});
